module.exports = __webpack_public_path__ + "img/1-1.83b71b29.png";